import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconShoppingCart } from '@redteclab/icons'

import { Button } from 'base-ui'

import {
  cartIntermediateAccessorGetRedPointsRedPointsAmountWithMultiplier,
  useProductAddToCart,
} from '../../../../../cart-intermediate'
import { Experiment } from '../../../../../experiments/components/Experiment'
import { ExperimentVariant } from '../../../../../experiments/components/ExperimentVariant'
import { EXPERIMENT_NAME_CART_INTERMEDIATE_DRAWER } from '../../../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../../../experiments/model/EXPERIMENT_VARIATION'
import { useProductPageContext } from '../../../productPageContext'
import { PRODUCT_ADD_TO_CART_FORM_ID } from '../../ProductAddToCartGroup/ProductAddToCartCta/ProductAddToCartCta'
import { useBuildAddToCartParams } from '../../ProductAddToCartGroup/ProductAddToCartCta/useBuildAddToCartParams'

export const ProductBuyBoxStickyAddToCart: FC = () => {
  const { disableCta } = useBuildAddToCartParams()
  const {
    currentOffer,
    currentPrescriptionType,
    product,
    quantitySelectionControls: { quantity },
  } = useProductPageContext()

  const redpoints = currentOffer
    ? cartIntermediateAccessorGetRedPointsRedPointsAmountWithMultiplier(
        currentOffer,
      )
    : 0

  const { handleAddToCart } = useProductAddToCart({
    currentPrescriptionType,
    offerId: currentOffer?.offerId,
    product,
    quantity,
    redpoints,
  })

  return (
    <Experiment names={[EXPERIMENT_NAME_CART_INTERMEDIATE_DRAWER]}>
      <ExperimentVariant name={EXPERIMENT_VARIATION.DEFAULT}>
        <Button
          className="w-full"
          data-qa-id="add-to-cart-button-sticky"
          disabled={disableCta}
          form={PRODUCT_ADD_TO_CART_FORM_ID}
          startIcon={<IconShoppingCart />}
          type="submit"
        >
          <FormattedMessage id="general.button.label.addToCart" />
        </Button>
      </ExperimentVariant>

      <ExperimentVariant name={EXPERIMENT_VARIATION.V1}>
        <Button
          className="w-full"
          data-qa-id="add-to-cart-button-sticky"
          disabled={disableCta}
          onClick={(): void => {
            void handleAddToCart()
          }}
          startIcon={<IconShoppingCart />}
          type="button"
        >
          <FormattedMessage id="general.button.label.addToCart" />
        </Button>
      </ExperimentVariant>
    </Experiment>
  )
}
